<template>
  <div class="container-page">
    <p class="title-inner">Торговля услугами России с выбранной страной</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-16">
      <SwitchComponent @switchHandler="switchType($event)" textTrue="Экспорт" textFalse="Импорт" />
    </div>
    <DefaultFilter class="mb-16" :filterValue="filter" @loadFilter="onLoadFilter" />
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Страна</th>
              <th>За год</th>
              <th>Квартал</th>
              <th>Услуга</th>
              <th>Значение</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.countryId"
                  placeholder="(Все)"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter"></th>
              <th class="filter"></th>
              <th class="filter"></th>
              <th class="filter"></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ getCountryName(item.countryId) }}</td>
              <td>{{ item.year }}</td>
              <td>{{ item.quartal }}</td>
              <td>
                {{ item.name }}
              </td>
              <td>{{ numberFormatter(item.value, 'ru-Ru', 3) }} млн $</td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="3">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="3">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal">
          <div class="form-group required">
            <label class="form-label" for="favor-report-year">За какой год данные</label>
            <input type="text" id="favor-report-year" class="form-control" v-model="reportYear" />
          </div>

          <div class="form-group required">
            <label class="form-label" for="favor-report-quartal">За какой квартал данные</label>
            <input type="text" id="favor-report-quartal" class="form-control" v-model="reportQuartal" />
          </div>
        </ImportModal>
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';
  import { numberFormatter } from '@/common/utils/numberFormatter';

  import SwitchComponent from '@/components/buttons/SwitchComponent.vue';
  import ImportModal from '@/components/modals/ImportModal.vue';
  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.FavorTradeView,
    import: Constants.Permissions.FavorTradeImport,
  };

  export default {
    name: 'FavorTrading',
    components: { FilterInput, ImportModal, ModalComponent, ButtonComponent, DefaultFilter, SwitchComponent },
    mixins: [security],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          IsExport: true,
        },
        filter: {
          countryId: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,
        select2Settings: Constants.select2Settings,
        countries: [],
        reportYear: '',
        reportQuartal: '',
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      numberFormatter,
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        Api.search('favortrade', request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylist', {})
          .then((response) => {
            this.countries = response.data;
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        if (this.reportYear && this.reportQuartal) {
          this.closeModal();
          this.importInProgress = true;

          Api.uploadFavorTradeFile(this.reportYear, this.request.IsExport, this.reportQuartal, file)
            .then(() => {
              Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
              this.loadPage();
              this.importInProgress = false;
            })
            .catch((error) => {
              Constants.alert.fire(
                'Импорт',
                error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
                'error',
              );
              this.importInProgress = false;
            });
        }
      },
      getCountryName(id) {
        if (id && this.countries.length) {
          return this.countries.find((item) => item.id == id).text;
        }
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      closeModal() {
        this.importModal = false;
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },

      switchType(event) {
        this.request.IsExport = event;
        this.loadPage(false);
      },
    },
  };
</script>
